import type React from 'react';

import { Typography } from '@material-ui/core';

interface IProps {
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  text: string;
  children?: React.ReactNode;
  className?: string;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Placeholder = ({ Icon, text, className = '', children }: IProps) => {
  return (
    <div className={`flex flex-col items-center justify-center space-y-2 text-balance text-center ${className}`}>
      {Icon && <Icon className='h-16 w-16' />}
      <Typography variant='body2' className='text-balance text-center'>
        {text}
      </Typography>
      {children}
    </div>
  );
};

export default Placeholder;
